import { toast } from "react-toastify";
import {
  ADD_DMPPLAYERS_ERROR,
  ADD_DMPPLAYERS_LOADING,
  ADD_DMPPLAYERS_SUCCESS,
  GET_DMPLIST_LOADING,
  GET_DMPLIST_ERROR,
  GET_DMPLIST_SUCCESS,
  GET_COURSE_INDEX_PAR_LOADING,
  GET_COURSE_INDEX_PAR_SUCCESS,
  CLEAR_COURSE_INDEX_PAR,
  GET_COURSE_INDEX_PAR_ERROR,
  CLEAR_DMPPLAYERS,
  GET_SELECTED_DMP_LEAGUE_LOADING,
  GET_SELECTED_DMP_LEAGUE_ID,
  CLEAR_SELECTED_DMP_LEAGUE_ID,
  GET_SELECTED_DMP_LEAGUE_ERROR,
  GET_SELECTED_DMP_LEAGUE_SUCCESS,
  CLEAR_SELECTED_DMP_LEAGUE,
  CLEAR_DMP_LIST,
} from "../../../constant/actionTypes";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import { apiGet, apiPut } from "../../../utils/apiRequests";

export const addDmpPlayersInMatch = (data) => (dispatch) => {
  dispatch({ type: ADD_DMPPLAYERS_LOADING });

  apiPut(
    `${ApiEndpoints.addPlayersInMatch.base}`,
    data,
    (response) => {
      if (response.error == true) {
        toast.error(response.error);
        dispatch({ type: ADD_DMPPLAYERS_ERROR, response: response.message });
      } else {
        dispatch({ type: ADD_DMPPLAYERS_SUCCESS, response: response });
        // dispatch({ type: CLEAR_DMPPLAYERS });
      }
    },
    (error) => {
      toast.error(error);
      dispatch({ type: ADD_DMPPLAYERS_ERROR, response: error });
    }
  );
};

export const clearDMPPlayersInMatch = () => (dispatch) => {
  dispatch({ type: CLEAR_DMPPLAYERS });
};

export const getDmpLists = () => (dispatch) => {
  dispatch({ type: GET_DMPLIST_LOADING });
  apiGet(
    ApiEndpoints.dmpleague.base,
    (response) => {
      if (response.error == true) {
        dispatch({ type: GET_DMPLIST_ERROR, response: response.message });
      } else {
        dispatch({ type: GET_DMPLIST_SUCCESS, response: response });
      }
    },
    (error) => {
      dispatch({ type: GET_DMPLIST_ERROR, response: error });
    }
  );
};

export const clearDmpLists = () => (dispatch) => {
  dispatch({
    type: CLEAR_DMP_LIST,
  });
};

export const getScoreCardParAndIndex = (id) => (dispatch) => {
  dispatch({
    type: GET_COURSE_INDEX_PAR_LOADING,
  });

  apiGet(
    `${ApiEndpoints.dmpgetcourseindexpar.base}${id}`,
    (response) => {
      if (response.error === true) {
        dispatch({
          type: GET_COURSE_INDEX_PAR_ERROR,
          response: response.message,
        });
      } else {
        if (response?.index_par.length > 0) {
          dispatch({ type: GET_COURSE_INDEX_PAR_SUCCESS, response: response });
        }
        else {
          toast.error('Invalid course name')
        }
      }
    },
    (error) => {
      dispatch({ type: GET_COURSE_INDEX_PAR_ERROR, response: error });
    }
  );
};

export const clearIndexParVal = () => (dispatch) => {
  dispatch({
    type: GET_COURSE_INDEX_PAR_SUCCESS,
  })
};


export const getSelectedDMPLeague = (leagueId) => (dispatch) => {
  dispatch({ type: GET_SELECTED_DMP_LEAGUE_LOADING });

  apiGet(
    `${ApiEndpoints.league.base}${ApiEndpoints.league.selectedLeague}/${leagueId}`,
    (response) => {
      if (response.error == true) {
        dispatch({
          type: GET_SELECTED_DMP_LEAGUE_ERROR,
          response: response.message,
        });
      } else {
        dispatch({ type: GET_SELECTED_DMP_LEAGUE_SUCCESS, response: response });
      }
    },
    (error) => {
      dispatch({ type: GET_SELECTED_DMP_LEAGUE_ERROR, response: error });
    }
  );
};

export const getSelectedDMPLeagueId = (id) => (dispatch) => {
  dispatch({
    type: GET_SELECTED_DMP_LEAGUE_ID,
    response: id,
  });
};

export const clearSelectedDMPLeague = () => (dispatch) => {
  dispatch({
    type: CLEAR_SELECTED_DMP_LEAGUE,
  });
};

export const clearSelectedDMPLeagueID = () => (dispatch) => {
  dispatch({
    type: CLEAR_SELECTED_DMP_LEAGUE_ID,
  });
};
